import axios from "axios";

export const creatProblem = async (username, problemVOToCreate) => {
    try {
        const {data} = await axios.post("/api/problem/create", {username, problemVOToCreate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateProblem = async (username, problemVOToUpdate) => {
    try {
        const {data} = await axios.post("/api/problem/update", {username, problemVOToUpdate});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}


export const viewProblemOverview = async (username, problemExternalReference) => {
    try {
        const {data} = await axios.get("/api/problem/viewProblemOverview?username=" + username + "&problemExternalReference=" + problemExternalReference);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const findProblemsByCriteria = async (username, trackerSearchInput) => {
    try {
        const {data} = await axios.post("/api/problem/findProblemsByCriteria" , {username, trackerSearchInput});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}


export const viewProblem = async (username, problemExternalReference) => {
    try {
        const {data} = await axios.post("/api/problem/view" , {username, problemExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteProblem = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/problem/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
